import { useMutation } from "@tanstack/react-query";
import { checkCreditCard } from "../../http/endpoints";
import { CheckCreditCardParams } from "@features/signup/types";

function useCheckCreditCard() {
  return useMutation({
    mutationFn: (params: CheckCreditCardParams) => checkCreditCard(params),
  });
}

export default useCheckCreditCard;
